export default {
  clearLanguageState: ({ commit }) => commit("CLEAR_LANGUAGE_STATE"),

  store: ({ commit }, payload) => commit("store", payload),

  delete: ({ commit }, payload) => commit("delete", payload),

  index: ({ commit }, payload) => commit("index", payload)
};
